export const DEFAULT_THUMBNAIL_WIDTH = 600;